import { createFileRoute } from "@tanstack/react-router"
import ComparisonPricingTable from "~/components/ComparisonPricingTable"
import MarketingPricingFAQ from "~/components/Marketing/MarketingPricingFAQ"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"
import CustomHead from "~/components/SEOHead/CustomHead"
import { getInternalPageTitle, InternalSection } from "~/utils/seo"

/**
 * https://dashboard.stripe.com/test/products?active=true
 */

const PricingTable = () => {
  const { data: products } = api.subscriptions.getProducts.useQuery()

  return (
    <>
      <CustomHead title={getInternalPageTitle(InternalSection.BILLING)} />

      <ComparisonPricingTable products={products ?? []} />

      <MarketingPricingFAQ className="mb-20" />
    </>
  )
}

function BillingPage() {
  return <PricingTable />
}

function BillingPageWrapper() {
  return (
    <AppLayout navIconFloat>
      <BillingPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/billing")({
  component: BillingPageWrapper,
})
